<template>
    <div class="modal-overlay">
        <transition name="modal-expand">
            <div v-if="isVisible" class="products-modal" @click.stop>
                <div class="modal-content" @click.stop> <!-- Stop the click event from propagating to the overlay -->
                    <font-awesome-icon class="window-close-icon" :icon="['fas', 'window-close']" @click="close" />
                    <h2>{{ isEdit ? 'Edit Task' : 'Add New Task' }}</h2>

                    <div class="add">
                        <form @submit.prevent="submit">
                            <div class="form-group">
                                <label for="chapt-no">ATA No:</label>
                                <input type="text" class="form-control rounded" id="chapt-no" name="chapt-no"
                                    v-model="form.chapt_no" />
                            </div>
                            <div class="form-group">
                                <label for="task-no">Task No:</label>
                                <input type="text" class="form-control rounded" id="task-no" name="task-no"
                                    v-model="form.task_no" />
                            </div>
                            <div class="form-group">
                                <label for="manob">MT/AT:</label>
                                <select class="form-control rounded" id="manob" name="manob" v-model="form.manob">
                                    <option value=""></option>
                                    <option value="MT">Main Task</option>
                                    <option value="AT">Additional Task</option>
                                </select>
                            </div>
                            <div class="form-group">
                                <label for="scope">Scope:</label>
                                <select class="form-control rounded" id="scope" name="scope" v-model="form.scope">
                                    <option value=""></option>
                                    <option value="LOC">LOC</option>
                                    <option value="FOT">FOT</option>
                                    <option value="SGH">SGH</option>
                                    <option value="R/I">R/I</option>
                                    <option value="MEL">MEL</option>
                                    <option value="TS">TS</option>
                                </select>
                            </div>
                            <div class="form-group">
                                <label for="description">Description:</label>
                                <input type="text" class="form-control rounded" id="description" name="description"
                                    placeholder="Enter Task Description" v-model="form.description" />
                            </div>

                            <div class="form-group">
                                <label for="reference">Reference:</label>
                                <input type="text" class="form-control rounded" id="reference" name="reference"
                                    placeholder="Enter Task Reference" v-model="form.reference" />
                            </div>
                            <!-- <div class="form-group">
                                <label for="location">Classroom/Aircraft:</label>
                                <select class="form-control rounded" id="location" name="location"
                                    v-model="form.location">
                                    <option value=""></option>
                                    <option value="Classroom">Classroom</option>
                                    <option value="Aircraft">Aircraft</option>
                                </select>
                            </div>

                            <div class="form-group">
                                <label for="skill">Skill:</label>
                                <select class="form-control rounded" id="skill" name="skill" v-model="form.skill">
                                    <option value=""></option>
                                    <option value="B1">B1</option>
                                    <option value="B2">B2</option>
                                    <option value="B1/B2">B1/B2</option>
                                </select>
                            </div> -->

                            <div class="form-group">
                                <label for="category">Category:</label>
                                <select class="form-control rounded" id="category" name="category"
                                    v-model="form.category">
                                    <option value=""></option>
                                    <option value="AF">AF</option>
                                    <option value="AV">AV</option>
                                    <option value="PP">PP</option>
                                </select>
                            </div>

                            <div v-if="showAlert" class="alert alert-danger error-message" role="alert">
                                <div v-if="errorMessage">{{ errorMessage }}</div>
                            </div>
                            <div>
                                <button class="saveButton" type="submit" style="margin-top: 10px;">{{ isEdit ? 'Update Task' : 'Save' }}</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>

import axios from 'axios';

export default {
    props: {
        tasks: Array,
        task: { type: Object, default: null }, // null = Add mode
        mode: { type: String, default: "add" },
        productId: { type: Number },
        projectId: { type: Number },
        isMandatory: { type: Boolean },
    },
    data() {
        return {
            form: {
                task_no: '',
                chapt_no: '',
                manob: '',
                product_id: '',
                project_id: '',
                reference: '',
                scope: '',
                description: '',
                category: '',
                skill: '',
                P1: '',
                P2: '',
                location: '',
            },
            newTask: {},
            showAlert: false,
            errorMessage: "",
            isVisible: false,
        };
    },
    computed: {
        isEdit() {
            return this.mode === "edit";
        },
        manobOptions() {
            if (this.isMandatory) {
                return [
                    { value: 'MT', label: 'Main Task' }
                ];
            }

            return [
                { value: 'MT', label: 'Main Task' },
                { value: 'AT', label: 'Additional Task' }
            ];
        }
    },
    methods: {
        close() {
            this.$emit('close');
        },
        async submit() {
            const normalize = (v) => (v ?? "").toString().trim().toLowerCase();

            const taskNo = normalize(this.form.task_no);
            const chaptNo = normalize(this.form.chapt_no);

            if (!this.form.task_no) {
                const tasksInChapter = this.tasks.filter(
                    task => task.chapt_no === this.form.chapt_no
                );

                if (tasksInChapter.length > 0) {
                    // Get max task_no from this chapter
                    const maxTaskNo = Math.max(
                        ...tasksInChapter.map(t => parseInt(t.task_no) || 0)
                    );
                    this.form.task_no = (maxTaskNo + 1).toString();
                } else {
                    // If no tasks exist yet for this chapter, start from 1
                    this.form.task_no = "1";
                }
            }

            const currentId = this.isEdit
                ? (this.task?.task_id ?? this.form.task_id ?? this.task?.id ?? this.form.id)
                : null;

            const isDuplicate = (this.tasks ?? []).some((t) => {
                const sameKey =
                    normalize(t.task_no) === taskNo &&
                    normalize(t.chapt_no) === chaptNo;

                const isSameRecord =
                    this.isEdit &&
                    normalize(t.task_id ?? t.id) === normalize(currentId);

                return sameKey && !isSameRecord;
            });

            if (isDuplicate) {
                window.alert("A task with this Task No and ATA No already exists");
                return;
            }

            this.form.product_id = this.productId;
            this.form.project_id = this.projectId;

            try {
                const token = localStorage.getItem("token");
                const headers = { Authorization: `Bearer ${token}` };

                let response;
                console.log('form', this.form);

                if (this.isEdit) {
                    // PUT update
                    response = await axios.put(`/api/tasks/${this.task.task_id}`, this.form, { headers });
                } else {
                    // POST add
                    response = await axios.post(`/api/tasks`, this.form, { headers });
                    this.newTask = response.data;
                    console.log('this.newTask', this.newTask);
                }

                if (response.status === 200 || response.status === 201) {
                    window.alert(`Task ${this.isEdit ? "updated" : "added"} successfully`);
                    this.$emit("saved");     // notify parent to refresh
                    this.close();
                }
            } catch (error) {
                if (error.isOffline === true) {
                    this.$emit('close');
                    return;
                }
                console.error('Error updating Task:', error.response);
                if (error.response && error.response.data && error.response.data.errors) {
                    // Handle validation errors
                    const validationErrors = error.response.data.errors;

                    // Build an error message from the validation errors
                    let errorMessage = 'Validation errors:';
                    for (const field in validationErrors) {
                        errorMessage += `\n${field}: ${validationErrors[field][0]}`;
                    }

                    this.errorMessage = errorMessage;
                } else {
                    // Handle other errors
                    this.errorMessage = 'An error occurred while updating the task.' + error.response.data.message;
                }
                this.showAlert = true;
            }
        },
    },
    mounted() {
        this.isVisible = true;
        console.log('project', this.projectId);
        console.log('mandatory', this.isMandatory);
        // Pre-fill fields for editing
        if (this.isEdit && this.task) {
            this.form = {
                ...this.form,
                ...this.task,
            };
            this.syncLocationFromP();
        }
    },
};

</script>

<style scoped>
.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    /* Semi-transparent background */
    display: flex;
    justify-content: center;
    align-items: top;
    z-index: 1000;
}

.products-modal {
    background-color: #ffffff;
    overflow-y: auto;
    /* Enables vertical scrolling if needed */
    margin-top: 25px;
    max-width: 90vw;
    max-height: 95vh;
    min-width: min(800px, 90%);
    padding: 10px;
    border-radius: 8px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.2);
    position: fixed;
    display: flex;
    flex-direction: column;
    overflow-wrap: break-word;
    padding: 20px;
    z-index: 1002;
}

.modal-content {
    border: white;
    padding: 15px;
    border: 1px solid #dddddd;
    border-radius: 3px;
}

.saveButton {
    background-color: #0055b1;
    color: #ffffff;
    font-size: 14px;
    padding: 10px;
    border: 1px solid #0a407a;
    border-radius: 4px;
    cursor: pointer;
    margin-bottom: auto;
    font-family: Verdana, Geneva, Tahoma, sans-serif;
    width: 180px;
    margin-left: 30px;
}

.saveButton:hover {
    background-color: rgb(1, 40, 82);
}

h2 {
    font-size: 30px;
    margin-bottom: 20px;
    margin-left: 25px;
}

.alert-danger {
    color: #ff0019;
    background-color: #f8d7da;
    border: 1px solid #e6b0b6;
}

.alert {
    position: relative;
    padding: .75rem 1.25rem;
    margin-bottom: 0rem;
    border: 1px solid transparent;
    border-radius: .25rem;
}

.form-group {
    display: flex;
    align-items: top;
    margin-bottom: 20px;
}

.form-group label {
    width: 150px;
    margin-right: 30px;
    text-align: right;
    margin-bottom: 0px;
    margin-top: 9px;
}

.form-group input.form-control,
.form-group select.form-control {
    flex: 1;
    width: auto;
    margin-left: 0;
    margin-bottom: 0px;
    height: 40px;
}

#chapt-no,
#task-no {
    flex: 0 0 80px;
    /* don't grow, don't shrink, fixed 100px */
    width: 80px;
}
</style>